import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import { setSound, playSong, selectCommon } from '../../common/actions/common.actions';
// import GearIcon from "../../../assets/icons/Gear.svg";
// import TranslateIcon from "../../../assets/icons/Google Translate.svg";
// import WhiteTranslate from "../../../assets/icons/whiteTranslate.svg";
// import LockIcon from "../../../assets/icons/Secure.svg";
// import SpeakerIcon from "../../../assets/icons/Speaker.svg";
// import WhiteSpeaker from "../../../assets/icons/whiteSpeaker.svg";
// import WhiteGear from "../../../assets/icons/whiteGear.svg";
// import WhiteLock from "../../../assets/icons/whiteSecure.svg";
import { Link, useNavigate } from "react-router-dom";
// import forwardArrow from "../../../assets/icons/left-arrow.png";
// import backArrow from "../../../assets/icons/Back.svg";
import { IoIosArrowBack } from "react-icons/io";
import { LiaLanguageSolid } from "react-icons/lia";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiFillSound } from "react-icons/ai";
import { BsGear } from "react-icons/bs";

const Setting = () => {
  const dispatch = useDispatch();
  const { soundOn } = useSelector(selectCommon)
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // add akn for click song
  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleCardClick = () => {
    dispatch(playSong());
    dispatch(setSound());
  };

  const onChangeLanguage = () => {
    handleSongClick();
    i18n.changeLanguage(i18n.language === "en" ? "mm" : "en");
    localStorage.setItem("language", i18n.language);
  };

  const handleBackClick = () => {
    navigate("/dashboard");
  };

  const handleChangePasswordClick = (e) => {
    handleSongClick();
    e.preventDefault();
    navigate("/change-password")
  }

  return (
    <div className="w-full flex flex-col font-dangrek h-[100dvh] overflow-hidden bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      {/* Professional Header */}
      <div className="flex justify-start items-center py-6 px-6 bg-white/80 backdrop-blur-xl dark:bg-gray-900/80 border-b border-gray-200/30 dark:border-gray-700/30 shadow-sm">
        <button
          className="w-12 h-12 mr-4 flex items-center justify-center text-gray-700 dark:text-white hover:bg-gray-100/80 dark:hover:bg-gray-800/80 rounded-xl transition-all duration-300 hover:scale-105 shadow-sm"
          onClick={handleBackClick}
        >
          <IoIosArrowBack size={24} className="text-gray-700 dark:text-white" />
        </button>
        <div className="flex items-center">
          <div className="w-10 h-10 bg-gradient-to-r from-red-600 to-red-700 rounded-xl flex items-center justify-center mr-4 shadow-lg">
            <BsGear size={20} className="text-white" />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">Settings</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Manage your preferences</p>
          </div>
        </div>
      </div>

      {/* Enhanced Content Area */}
      <div className="flex flex-1 flex-col p-6 overflow-auto bg-gradient-to-br from-blue-50/50 via-white/50 to-purple-50/50 dark:from-gray-900/50 dark:via-gray-800/50 dark:to-gray-900/50">
        {/* Language Setting Card */}
        <div
          onClick={onChangeLanguage}
          className="cursor-pointer group mb-4 p-6 bg-white/90 dark:bg-gray-800/90 backdrop-blur-xl rounded-2xl border border-gray-200/50 dark:border-gray-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02] hover:bg-white dark:hover:bg-gray-800"
        >
          <div className="flex items-center">
            <div className="w-12 h-12 bg-gradient-to-r from-red-600 to-red-700 rounded-xl flex items-center justify-center mr-4 shadow-md group-hover:shadow-lg transition-shadow duration-300">
              <LiaLanguageSolid size={24} className="text-white" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{t('language')}</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">Change app language</p>
            </div>
            <div className="text-gray-400 dark:text-gray-500 group-hover:text-blue-500 dark:group-hover:text-blue-400 transition-colors duration-300">
              <IoIosArrowBack size={20} className="rotate-180" />
            </div>
          </div>
        </div>

        {/* Change Password Card */}
        <Link className="z-40 w-full mb-4" onClick={(e) => handleChangePasswordClick(e)}>
          <div className="group p-6 bg-white/90 dark:bg-gray-800/90 backdrop-blur-xl rounded-2xl border border-gray-200/50 dark:border-gray-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02] hover:bg-white dark:hover:bg-gray-800">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-gradient-to-r from-red-600 to-red-700 rounded-xl flex items-center justify-center mr-4 shadow-md group-hover:shadow-lg transition-shadow duration-300">
                <RiLockPasswordFill size={22} className="text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{t('changePassword')}</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">Update your password</p>
              </div>
              <div className="text-gray-400 dark:text-gray-500 group-hover:text-blue-500 dark:group-hover:text-blue-400 transition-colors duration-300">
                <IoIosArrowBack size={20} className="rotate-180" />
              </div>
            </div>
          </div>
        </Link>

        {/* Sound Setting Card */}
        <div
          className="group cursor-pointer p-6 bg-white/90 dark:bg-gray-800/90 backdrop-blur-xl rounded-2xl border border-gray-200/50 dark:border-gray-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02] hover:bg-white dark:hover:bg-gray-800 mb-4"
          onClick={handleCardClick}
        >
          <div className="flex items-center">
            <div className="w-12 h-12 bg-gradient-to-r from-red-600 to-red-700 rounded-xl flex items-center justify-center mr-4 shadow-md group-hover:shadow-lg transition-shadow duration-300">
              <AiFillSound size={24} className="text-white" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">Betting Click Sound</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">Toggle sound effects</p>
            </div>
            <div className="flex items-center">
              <span className={`px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 shadow-sm ${
                soundOn === "true" 
                  ? "bg-gradient-to-r from-green-400 to-green-500 text-white shadow-green-200 dark:shadow-green-900/50" 
                  : "bg-gradient-to-r from-gray-300 to-gray-400 text-gray-700 dark:from-gray-600 dark:to-gray-700 dark:text-gray-300"
              }`}>
                {soundOn === "true" ? "ON" : "OFF"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Footer */}
      <div className="h-16 flex justify-center items-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border-t border-gray-200/30 dark:border-gray-700/30">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Version 2.0.1.8</p>
        </div>
      </div>
    </div>
  );
};

export default Setting;
